import React, { useEffect, useState } from "react";
import { Button, CloseButton, Col, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Select from "./Select";
import axios from "axios";
import { API_URL } from "../../../services/api";
import { useCookies } from "react-cookie";
import toast, { Toaster } from "react-hot-toast";
import { edit_input } from "../Service";

const EditableInput = ({
    setEditableInput,
    item,
    dataInput,
    setDataInput,
    edition,
    replyTo,
    setReplyTo,
}) => {
    const [requiredInput, setRequiredInput] = useState();
    const [errorMessage, setErrorMessage] = useState();
    useEffect(() => {
        setRequiredInput(item.required);
        setErrorMessage(item.error);
        setEditInput(item);
        setDataSelectArray(item.selectedDataArray);

        if (item.type) {
            setIsSelect(item.type);
        } else {
            if (item.input.type) {
                setIsSelect(item.input.type);
            }
        }
    }, [item]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [token, setToken] = useCookies(["token"]);

    const [editInput, setEditInput] = useState();
    const [dataSelectArray, setDataSelectArray] = useState();
    const [isSelect, setIsSelect] = useState();

    const deleteInput = (key) => {
        const newDataInput = dataInput.filter((element) =>
            element.data !== undefined
                ? element.data.key !== key
                : element.id !== key
        );
        setDataInput(newDataInput);
    };

    const deleteInputForm = () => {
        deleteInput(item.id);
        const data = { _method: "delete", id: item.id };

        const headers = {
            headers: {
                Authorization: `Bearer ${token.token}`,
            },
        };

        axios
            .post(API_URL + "form-input/" + item.id, data, headers)
            .then((response) => {
                const message = response.data.message;
                toast.success("Deleted");
                setEditableInput(false);
            })
            .catch((error) => {
                toast.error("Not deleted");
            })
            .finally(() => {});
    };

    const changeReply = () => {
        if (edition == false) {
            dataInput.map((item) => {
                if (item.data.reply_to == 1) {
                    item.data.reply_to = 0;
                }
            });
        }
    };

    const handleChange = (event) => {
        let value = event.target.value;
        let checked = event.target.checked;
        if (event.target.name === "required") {
            if (checked) {
                value = 1;
                setRequiredInput(value);
            } else {
                value = 0;
                setRequiredInput(value);
            }
        }

        if (event.target.name === "error") {
            if (checked) {
                value = 1;
                setErrorMessage(value);
            } else {
                value = 0;
                setErrorMessage(value);
            }
        }

        if (event.target.name === "reply_to") {
            changeReply();
            if (checked) {
                value = 1;
            } else {
                value = 0;
                setReplyTo(0);
            }
        }

        setEditInput({
            ...editInput,
            [event.target.name]: value,
        });
    };

    const editPreview = () => {
        let elementIndex = dataInput.findIndex((obj) =>
            //Este if determinia si se esta editando de ingreso o de el compenete de editar
            obj.data === undefined
                ? obj.id == item.id
                : obj.data.key == item.key
        );
        Object.entries(editInput).forEach(([key, value]) => {
            // dataInput[elementIndex].data[key] = editInput[key];
            if (dataInput[elementIndex].data === undefined) {
                dataInput[elementIndex][key] = editInput[key];
            } else {
                dataInput[elementIndex].data[key] = editInput[key];
            }
        });
        setShow(false);
        setEditableInput(false);
    };

    const editForm = async () => {
        const res = await edit_input(editInput, dataSelectArray, token);
        if (res.success) {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
    };

    return (
        <div className=" col-9 mt-3 border rounded-3 pt-3 pb-3">
            <div className="d-grid gap-2 col-10 mx-auto">
                <div className="d-flex justify-content-between">
                    {item.label}
                    <CloseButton
                        onClick={() => {
                            setEditableInput(false);
                        }}
                    />
                </div>
                <Button variant="success" onClick={handleShow}>
                    Edit
                </Button>
                <Button
                    variant="warning"
                    onClick={() => {
                        edition ? deleteInputForm() : deleteInput(item.key);
                    }}
                >
                    Delete
                </Button>
            </div>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit {item.type}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form
                    // onSubmit={submit}
                    >
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Label</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                name="label"
                                defaultValue={item.label}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>Placeholder</Form.Label>
                            <Form.Control
                                size="sm"
                                type="text"
                                name="placeholder"
                                defaultValue={item.placeholder}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        {item.input_id == 4 && (
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Check
                                    defaultChecked={
                                        item.reply_to == 1 ? true : false
                                    }
                                    inline
                                    type="checkbox"
                                    aria-label="option 5"
                                    label="Responder a este correo"
                                    name="reply_to"
                                    onClick={handleChange}
                                    disabled={
                                        edition &&
                                        replyTo == 1 &&
                                        item.reply_to == 0
                                            ? true
                                            : false
                                    }
                                />
                            </Form.Group>
                        )}

                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Check
                                inline
                                aria-label="option 1"
                                label="Required"
                                name="required"
                                onChange={handleChange}
                                defaultChecked={
                                    requiredInput === 1 ? true : false
                                }
                            />
                            {requiredInput == 1 && (
                                <Form.Check
                                    inline
                                    aria-label="option 1"
                                    label="Error Message"
                                    name="error"
                                    onChange={handleChange}
                                    defaultChecked={
                                        errorMessage == 1 ? true : false
                                    }
                                />
                            )}
                        </Form.Group>

                        {errorMessage == 1 && (
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Message error</Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    name="error_message"
                                    defaultValue={item.error_message}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        )}

                        <Form.Group className="mb-3">
                            <Form.Label>Field size</Form.Label>
                            <Form.Select
                                name="size"
                                onChange={handleChange}
                                defaultValue={item.size}
                            >
                                <option value={0}>Medium</option>
                                <option value={1}>Complete</option>
                            </Form.Select>
                        </Form.Group>

                        {isSelect == "select" && (
                            <Select
                                dataSelect={dataSelectArray}
                                setDataSelect={setDataSelectArray}
                            />
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    {edition ? (
                        <Button
                            variant="primary"
                            onClick={() => {
                                editPreview();
                                editForm();
                            }}
                        >
                            Edit
                        </Button>
                    ) : (
                        <Button
                            variant="primary"
                            onClick={() => {
                                editPreview();
                            }}
                        >
                            Save Changes
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EditableInput;
